<template>
    <div id="my-applications">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="kingsGreen" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <my-applications-toolbar></my-applications-toolbar>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <my-applications-manager ref="applicationsManager" :data="data" :user="user">
                    </my-applications-manager>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import MyApplicationsManager from '../../components/Student/MyApplications/Manager';
import MyApplicationsToolbar from '../../components/Student/MyApplications/Toolbar';

export default {
    name: 'my-applications',
    components: {
        MyApplicationsManager,
        MyApplicationsToolbar
    },
    props: {
        id: {
            required: false
        },
        user: {
            required: true
        }
    },
    data() {
        return {
            activeApplication: true,
            data: [],
            loader: true,
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            },
            refreshTimer: '',
        }
    },
    methods: {
        getApplicationsData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplications`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Your applications could not be retrieved. Please contact your system administrator.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else {
                        that.data = json.data;

                        if (that.activeApplication && that.id) {
                            that.setActiveApplication(that.id);
                        }
                    }

                    that.activeApplication = false;
                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        refreshData() {
            this.getApplicationsData();
        },
        setActiveApplication(id) {
            if (id) {
                let application = '';

                // Find application
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].id == id) {
                        application = this.data[i];
                        break
                    }
                }

                if (application) {
                    this.$refs.applicationsManager.openDialog(application);
                } else {
                    this.setNotification('#ffb822', 'mdi-file-alert', `The application could not be found. Either the id is invalid or the application does not exist.`, true);
                }
            }
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        }
    },
    computed: {
        kingsGreen() {
            return '#004236';
        }
    },
    created() {
        this.refreshData();
        this.refreshTimer = setInterval(this.refreshData, 120000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>